import React from 'react'

import Layout from '../components/Layout'
import {Posts} from '../components/Main'

const Lifestyle = ({ location }) => {
    return (
        <Layout location={location}>
            <Posts pageTitle={'Lifestyle'} category={['lifestyle']} />
        </Layout>
    )
}

export default Lifestyle
